"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const Sentry = __importStar(require("@sentry/react"));
const react_query_1 = require("@tanstack/react-query");
const history_1 = require("history");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_toastify_1 = require("react-toastify");
const GlobalModal_1 = __importDefault(require("../../common/js/components/GlobalModal"));
const locale_1 = require("../../common/js/helper/locale");
const sentry_1 = require("../../common/js/setup/sentry");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Paths = __importStar(require("../constants/Paths"));
const Routes_1 = __importDefault(require("../constants/Routes"));
const locale_2 = require("../helper/locale");
const queryClient_1 = require("../setup/queryClient");
const Route_1 = __importDefault(require("../stores/Route"));
const Root_1 = __importDefault(require("./Root"));
const ScrollReset_1 = __importDefault(require("./ScrollReset"));
const history = (0, history_1.createBrowserHistory)();
if (SENTRY_ENABLED) {
    (0, sentry_1.enableSentry)({
        integrations: [
            Sentry.reactRouterV5BrowserTracingIntegration({
                routes: Routes_1.default,
                history: history,
                matchPath: react_router_dom_1.matchPath,
            }),
            ...sentry_1.sentryIntegrations,
        ],
    });
}
const App = () => {
    const location = (0, react_router_dom_1.useLocation)();
    /*
     * Only render content after RouteStore has been initialized to ensure locale redirects work as expected by being
     * able to determine the correct locale in the URL and to be able to redirect as otherwise history is not available.
     * Only using it for "Root" component as upon login the "Auth0Provider" has to handle the auth0 login immediately.
     */
    const routeStoreInitialized = undefined !== Route_1.default.history && undefined !== Route_1.default.location;
    const scopes = ['openid', 'profile', 'email', 'offline_access'].concat(AuthorizationStore_1.default.scopes);
    let localeCode = (0, locale_2.determineLocale)();
    const parameters = new URLSearchParams(location.search);
    const isModuleLogin = ['download', 'service'].includes(parameters.get('isModuleLogin') ?? '');
    (0, react_1.useEffect)((0, mobx_1.action)(() => {
        Route_1.default.history = history;
        Route_1.default.location = location;
        const regex = new RegExp(`^/(${Object.keys(__APP__.LOCALE_MAP || {}).join('|')})(/|$)`);
        const locale = (Route_1.default.location?.pathname?.match(regex) ?? [])[1] ?? null;
        const sanitizedLocale = (0, locale_1.getLanguageFromLocale)(locale);
        if (Route_1.default.localeOfUrl !== sanitizedLocale) {
            Route_1.default.localeOfUrl = sanitizedLocale;
            localeCode = sanitizedLocale ?? (0, locale_2.determineLocale)();
        }
    }), [location, history]);
    return (react_1.default.createElement(auth0_react_1.Auth0Provider, { domain: __APP__.AUTH0_DOMAIN, clientId: __APP__.AUTH0_CLIENT_ID, redirectUri: window.location.origin, scope: scopes.join(' '), cacheLocation: "memory", useRefreshTokens: true, audience: __APP__.AUTH0_AUDIENCE_PORTAL, onRedirectCallback: (appState) => {
            if (appState?.moduleReturnTo) {
                window.location.replace(window.location.origin + appState?.moduleReturnTo);
                return;
            }
            if (appState?.returnTo) {
                history.replace(Paths.PATH_HOME.replace(':locale', localeCode), { returnTo: appState.returnTo });
            }
        } },
        react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient_1.queryClient }, isModuleLogin ? null : (react_1.default.createElement("div", { className: "znd-app" },
            react_1.default.createElement(ScrollReset_1.default, null),
            routeStoreInitialized ? react_1.default.createElement(Root_1.default, null) : null,
            react_1.default.createElement(react_toastify_1.ToastContainer, { position: "bottom-left", autoClose: 8000, newestOnTop: false, closeOnClick: true, transition: react_toastify_1.Slide, rtl: false, pauseOnFocusLoss: true, draggable: false, hideProgressBar: false, pauseOnHover: true, closeButton: false }),
            react_1.default.createElement(GlobalModal_1.default, null))))));
};
// To ensure component is re-rendered after RouteStore has been initialized.
const ObserverApp = (0, mobx_react_1.observer)(App);
const RouterWrapper = () => (react_1.default.createElement(react_router_dom_1.Router, { history: history },
    react_1.default.createElement(ObserverApp, null)));
exports.default = SENTRY_ENABLED ? Sentry.withProfiler(RouterWrapper, { name: 'Portal' }) : RouterWrapper;
